import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Container, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Typography, Toolbar, Hidden } from '@material-ui/core';

import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import PropertyMenu from './PropertyMenu' // メニュー

import { useDispatch, useSelector } from 'react-redux';
import {
    setAutomobile,
    clearAutomobile,
} from '../stores/automobile'

import Explanation from './Explanation'
import MenuList from './MenuList' // その他
import GuideHalf from './GuideHalf' // ガイド

import FlowTitle from './FlowTitle' // フロータイトル
import FlowItem from './FlowItem' // フローアイテム
import FlowArrow from './FlowArrow' // フローアロー

import PageExplanation from './PageExplanation'

import PageStep from './PageStep' // ステップ
import PropertyStep from './PropertyStep' // 財産ステップ

import TargetPerson from './TargetPerson' // 相続人
import InheritanceBequest from './InheritanceBequest' // 相続・遺贈

const useStyles = makeStyles((theme) => ({
    head: {
        backgroundColor: '#3f51b5',
        color: '#fff'
    },
    required: {
        '& .MuiFormHelperText-root': {
            color: '#f00'
        }
    },
    listWrap: {
        width: '100%',
        marginTop: '10px'
    },
    center: {
        textAlign: 'center'
    },
    cellButton: {
        width: '15%'
    }
}));

// 自動車
function Automobile(){
    const dispatch = useDispatch();

    const igonFlag = useSelector(state => state.igon.igonFlag);
    const automobile = useSelector(state => state.automobile.automobile);
    const heiress = useSelector(state => state.heiress.heiress);

    const [error, setError] = useState(null);

    const handleAutomobile = (event) => {
        const registrationNumber = document.getElementById('automobile_registration_number').value;
        const type = document.getElementById('automobile_type').value;
        const use = document.getElementById('automobile_use').value;
        const privateBusiness = document.getElementById('automobile_private_business').value;
        const name = document.getElementById('automobile_name').value;
        const model = document.getElementById('automobile_model').value;
        const chassisNumber = document.getElementById('automobile_chassis_number').value;
        const primeMoverModel = document.getElementById('automobile_prime_mover_model').value;

        if(registrationNumber == ''){
            checkRegistrationNumber(true);
            registrationNumberHelper('登録番号は必ずご入力くさだい。');
            setError('エラーが発生しました。登録番号は必ずご入力くさだい。');
            return;
        }else if(type == ''){
            checkType(true);
            typeHelper('種別は必ずご入力くさだい。');
            setError('エラーが発生しました。種別は必ずご入力くさだい。');
            return;
        }else if(use == ''){
            checkUse(true);
            automobileUseHelper('用途は必ずご入力くさだい。');
            setError('エラーが発生しました。用途は必ずご入力くさだい。');
            return;
        }else if(privateBusiness == ''){
            checkPrivateBusiness(true);
            privateBusinessHelper('自家用・事業用の別は必ずご入力くさだい。');
            setError('エラーが発生しました。自家用・事業用の別は必ずご入力くさだい。');
            return;
        }else if(name == ''){
            checkName(true);
            nameHelper('車名は必ずご入力くさだい。');
            setError('エラーが発生しました。車名は必ずご入力くさだい。');
            return;
        }else if(model == ''){
            checkModel(true);
            modelHelper('型式は必ずご入力くさだい。');
            setError('エラーが発生しました。型式は必ずご入力くさだい。');
            return;
        }else if(chassisNumber == ''){
            checkChassisNumber(true);
            chassisNumberHelper('車台番号は必ずご入力くさだい。');
            setError('エラーが発生しました。車台番号は必ずご入力くさだい。');
            return;
        }else if(primeMoverModel == ''){
            checkPrimeMoverModel(true);
            primeMoverMobileHelper('原動機の型式は必ずご入力くさだい。');
            setError('エラーが発生しました。原動機の型式は必ずご入力くさだい。');
            return;
        }

        let targetPerson = null;
        let inheritanceBequest = null;

        if(igonFlag){
            targetPerson = document.getElementsByName('automobile_target_person')[0].value;
            inheritanceBequest = document.getElementsByName('automobile_inheritance_bequest')[0].value;
            if(igonFlag && targetPerson == ''){
                checkTargetPerson(true);
                targetPersonHelper('取得対象者は必ずご入力くさだい。');
                setError('エラーが発生しました。取得対象者は必ずご入力くさだい。');
                return;
            }else if(igonFlag && inheritanceBequest == ''){
                checkInheritanceBequest(true);
                inheritanceBequestHelper('相続・遺贈は必ずご入力くさだい。');
                setError('エラーが発生しました。相続・遺贈は必ずご入力くさだい。');
                return;
            }

            targetPerson = heiress[targetPerson].name;
        }

        document.getElementById('automobile_registration_number').value = '';
        document.getElementById('automobile_type').value = '';
        document.getElementById('automobile_use').value = '';
        document.getElementById('automobile_private_business').value = '';
        document.getElementById('automobile_name').value = '';
        document.getElementById('automobile_model').value = '';
        document.getElementById('automobile_chassis_number').value = '';
        document.getElementById('automobile_prime_mover_model').value = '';

        setRegistrationNumberValue(null);
        setTypeValue(null);
        setUseValue(null);
        setPrivateBusinessValue(null);
        setNameValue(null);
        setModelValue(null);
        setChassisNumberValue(null);
        setPrimeMoverModelValue(null);

        if(igonFlag){
            setTargetPersonValue(null);
            setInheritanceBequestValue(null);
        }

        const automobile = {
            registrationNumber: registrationNumber,
            type: type,
            use: use,
            privateBusiness: privateBusiness,
            name: name,
            model: model,
            chassisNumber: chassisNumber,
            primeMoverModel: primeMoverModel,
            targetPerson: targetPerson,
            inheritanceBequest: inheritanceBequest,
        };

        setError('登録しました。');

        dispatch(setAutomobile(automobile));
    }

    // 編集
    const [registrationNumberValue, setRegistrationNumberValue] = useState(null);
    const [typeValue, setTypeValue] = useState(null);
    const [useValue, setUseValue] = useState(null);
    const [privateBusinessValue, setPrivateBusinessValue] = useState(null);
    const [nameValue, setNameValue] = useState(null);
    const [modelValue, setModelValue] = useState(null);
    const [chassisNumberValue, setChassisNumberValue] = useState(null);
    const [primeMoverModelValue, setPrimeMoverModelValue] = useState(null);
    const [targetPersonValue, setTargetPersonValue] = useState(null);
    const [inheritanceBequestValue, setInheritanceBequestValue] = useState(null);

    const handleAutomobileEdit = (index, event) => {
        const automobileEdit = automobile[index];

        setRegistrationNumberValue(automobileEdit.registrationNumber);
        setTypeValue(automobileEdit.type);
        setUseValue(automobileEdit.type);
        setPrivateBusinessValue(automobileEdit.privateBusiness);
        setNameValue(automobileEdit.name);
        setModelValue(automobileEdit.model);
        setChassisNumberValue(automobileEdit.chassisNumber);
        setPrimeMoverModelValue(automobileEdit.primeMoverModel);
        setTargetPersonValue(index);
        setInheritanceBequestValue(automobileEdit.inheritanceBequest);

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

        dispatch(clearAutomobile(index));
    }

    // 削除
    const handleAutomobileDelete = (index, event) => {
        dispatch(clearAutomobile(index));
        setOpen(false);
    }

    // 必須項目
    const [registrationNumberHelperText,registrationNumberHelper] = useState('必須');
    const [typeHelperText, typeHelper] = useState('必須');
    const [automobileUseHelperText, automobileUseHelper] = useState('必須');
    const [privateBusinessHelperText, privateBusinessHelper] = useState('必須');
    const [nameHelperText, nameHelper] = useState('必須');
    const [modelHelperText, modelHelper] = useState('必須');
    const [chassisNumberHelperText, chassisNumberHelper] = useState('必須');
    const [primeMoverModelHelperText, primeMoverMobileHelper] = useState('必須');
    const [targetPersonHelperText, targetPersonHelper] = useState('必須');
    const [inheritanceBequestHelperText, inheritanceBequestHelper] = useState('必須');

    const [registrationNumberValidate, checkRegistrationNumber] = useState(false);
    const handleRegistrationNumber = (event) => {
        if(event.target.value){
            checkRegistrationNumber(false);
            registrationNumberHelper('必須');
            setRegistrationNumberValue(event.target.value);
        }else{
            checkRegistrationNumber(true);
            registrationNumberHelper('登録番号は必ずご入力ください。');
            setRegistrationNumberValue(null);
        }
    }

    const [typeValidate, checkType] = useState(false);
    const handleType = (event) => {
        if(event.target.value){
            checkType(false);
            typeHelper('必須');
            setTypeValue(event.target.value);
        }else{
            checkType(true);
            typeHelper('種別は必ずご入力ください。');
            setTypeValue(null);
        }
    }

    const [useValidate, checkUse] = useState(false);
    const handleUse = (event) => {
        if(event.target.value){
            checkUse(false);
            automobileUseHelper('必須');
            setUseValue(event.target.value);
        }else{
            checkUse(true);
            automobileUseHelper('用途は必ずご入力くさだい。');
            setUseValue(null);
        }
    }

    const [privateBusinessValidate, checkPrivateBusiness] = useState(false);
    const handlePrivateBusiness = (event) => {
        if(event.target.value){
            checkPrivateBusiness(false);
            primeMoverMobileHelper('必須');
            setPrivateBusinessValue(event.target.value);
        }else{
            checkPrivateBusiness(true);
            primeMoverMobileHelper('自家用・事業用の別は必ずご入力ください。');
            setPrivateBusinessValue(null);
        }
    }

    const [nameValidate, checkName] = useState(false);
    const handleName = (event) => {
        if(event.target.value){
            checkName(false);
            nameHelper('必須');
            setNameValue(event.target.value);
        }else{
            checkName(true);
            nameHelper('車名は必ずご入力くさだい。');
            setNameValue(null);
        }
    }

    const [modelValidate, checkModel] = useState(false);
    const handleModel = (event) => {
        if(event.target.value){
            checkModel(false);
            modelHelper('必須');
            setModelValue(event.target.value);
        }else{
            checkModel(true);
            modelHelper('型式は必ずご入力くさだい。');
            setModelValue(null);
        }
    }

    const [chassisNumberValidate, checkChassisNumber] = useState(false);
    const handleChassisNumber = (event) => {
        if(event.target.value){
            checkChassisNumber(false);
            chassisNumberHelper('必須');
            setChassisNumberValue(event.target.value);
        }else{
            checkChassisNumber(true);
            chassisNumberHelper('車台番号は必ずご入力くさだい。');
            setChassisNumberValue(null);
        }
    }

    const [primeMoverModelValidate, checkPrimeMoverModel] = useState(false);
    const handlePrimeMoverModel = (event) => {
        if(event.target.value){
            checkPrimeMoverModel(false);
            primeMoverMobileHelper('必須');
            setPrimeMoverModelValue(event.target.value);
        }else{
            checkPrimeMoverModel(true);
            primeMoverMobileHelper('原動機の型式は必ずご入力くさだい。');
            setPrimeMoverModelValue(null);
        }
    }

    const [targetPersonValidate, checkTargetPerson] = useState(false);
    const handleTargetPerson = (event) => {
        if(event.target.value != null){
            checkTargetPerson(false);
            targetPersonHelper('必須');
            setTargetPersonValue(event.target.value);
        }else{
            checkTargetPerson(true);
            targetPersonHelper('取得対象者は必ずご入力くさだい。');
            setTargetPersonValue(null);
        }
    }

    const [inheritanceBequestValidate, checkInheritanceBequest] = useState(false);
    const handleInheritanceBequest = (event) => {
        if(event.target.value){
            checkInheritanceBequest(false);
            inheritanceBequestHelper('必須');
            setInheritanceBequestValue(event.target.value);
        }else{
            checkInheritanceBequest(true);
            inheritanceBequestHelper('相続・遺贈は必ずご入力くさだい。');
            setInheritanceBequestValue(null);
        }
    }

    const [deleteTargetIndex, deleteTarget] = useState(null);

    const [open, setOpen] = useState(false);

    const handleDialogOpen = (index) => {
        setOpen(true);
        deleteTarget(index);
    }

    const handleDialogClose = () => {
        setOpen(false);
    }

    const classes = useStyles();

    return(
        <Container>
            <Grid container spacing={3}>
                <Grid item xs={12} lg={6}>
                    <PageExplanation pageName="自動車" firstItemName="登録番号" igonFlag={igonFlag}/>

                    <PageStep activeStep={1}/>

                    <PropertyStep activeStep={0} nowPage="automobile"/>

                    <MenuList pageName="自動車" />

                    <TextField
                        id="automobile_registration_number"
                        name="automobile_registration_number"
                        label="登録番号"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="登録番号をご入力ください。"
                        helperText={registrationNumberHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleRegistrationNumber}
                        onChange={handleRegistrationNumber}
                        error={registrationNumberValidate}
                        value={registrationNumberValue}
                    />
                    <TextField
                        id="automobile_type"
                        name="automobile_type"
                        label="種別"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="種別をご入力ください。"
                        helperText={typeHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleType}
                        onChange={handleType}
                        error={typeValidate}
                        value={typeValue}
                    />
                    <TextField
                        id="automobile_use"
                        name="automobile_use"
                        label="用途"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="用途をご入力ください。"
                        helperText={automobileUseHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleUse}
                        onChange={handleUse}
                        error={useValidate}
                        value={useValue}
                    />
                    <TextField
                        id="automobile_private_business"
                        name="automobile_private_business"
                        label="自家用・事業用の別"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="自家用・事業用の別をご入力ください。"
                        helperText={privateBusinessHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handlePrivateBusiness}
                        onChange={handlePrivateBusiness}
                        error={privateBusinessValidate}
                        value={privateBusinessValue}
                    />
                    <TextField
                        id="automobile_name"
                        name="automobile_name"
                        label="車名"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="車名をご入力ください。"
                        helperText={nameHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleName}
                        onChange={handleName}
                        error={nameValidate}
                        value={nameValue}
                    />
                    <TextField
                        id="automobile_model"
                        name="automobile_model"
                        label="型式"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="型式をご入力ください。"
                        helperText={modelHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleModel}
                        onChange={handleModel}
                        error={modelValidate}
                        value={modelValue}
                    />
                    <TextField
                        id="automobile_chassis_number"
                        name="automobile_chassis_number"
                        label="車台番号"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="車台番号をご入力ください。"
                        helperText={chassisNumberHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleChassisNumber}
                        onChange={handleChassisNumber}
                        error={chassisNumberValidate}
                        value={chassisNumberValue}
                    />
                    <TextField
                        id="automobile_prime_mover_model"
                        name="automobile_prime_mover_model"
                        label="原動機の型式"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="原動機の型式をご入力ください。"
                        helperText={primeMoverModelHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handlePrimeMoverModel}
                        onChange={handlePrimeMoverModel}
                        error={primeMoverModelValidate}
                        value={primeMoverModelValue}
                    />
                    <TargetPerson targetPersonId="automobile_target_person" targetPersonName="automobile_target_person" targetPersonValue={targetPersonValue} targetPersonHelperText={targetPersonHelperText} targetPersonValidate={targetPersonValidate} handleTargetPerson={handleTargetPerson}/>
                    <InheritanceBequest inheritanceBequestId="automobile_inheritance_bequest" inheritanceBequestName="automobile_inheritance_bequest" inheritanceBequestHelperText={inheritanceBequestHelperText} handleInheritanceBequest={handleInheritanceBequest} inheritanceBequestValidate={inheritanceBequestValidate} inheritanceBequestValue={inheritanceBequestValue}/>

                    <Explanation/>

                    <Paper className={classes.listWrap}>
                        <Toolbar>
                            <Typography variant="h6">今入力されている自動車の一覧</Typography>
                        </Toolbar>
                            {
                                (()=>{
                                    if(automobile !== undefined && automobile.length){
                                        return (
                                            <>
                                            <Hidden smDown>
                                            <TableContainer component={Paper} className={classes.list}>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell className={classes.head}>登録番号</TableCell>
                                                            <TableCell className={classes.head}>種別</TableCell>
                                                            <TableCell className={classes.head}>車名</TableCell>
                                                            <TableCell className={classes.head}>&nbsp;</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                    {automobile.map((row, index) => {
                                                        return (
                                                            <TableRow hover>
                                                                <TableCell>{row.registrationNumber}</TableCell>
                                                                <TableCell>{row.type}</TableCell>
                                                                <TableCell>{row.name}</TableCell>
                                                                <TableCell>
                                                                    <Button
                                                                        variant="contained"
                                                                        color="default"
                                                                        style={{ margin: 8 }}
                                                                        onClick={(event) => { handleAutomobileEdit(index, event) }}
                                                                        startIcon={<EditIcon/>}
                                                                        className={classes.operating}
                                                                    >
                                                                    編集
                                                                    </Button>
                                                                    <Button
                                                                        variant="contained"
                                                                        color="default"
                                                                        style={{ margin: 8 }}
                                                                        onClick={(event) => { handleDialogOpen(index) }}
                                                                        startIcon={<DeleteIcon/>}
                                                                        className={classes.operating}
                                                                    >
                                                                    削除
                                                                    </Button>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            </Hidden>

                                            <Hidden mdUp>
                                                <TableContainer component={Paper} className={classes.list}>
                                                    <Table size="small">
                                                        {automobile.map((row, index) => {
                                                            return (
                                                                <>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell className={classes.head} colspan={2}>財産番号&nbsp;自動車({index+1})</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                <TableRow hover>
                                                                    <TableCell>登録番号</TableCell>
                                                                    <TableCell>{row.registrationNumber}</TableCell>
                                                                </TableRow>
                                                                <TableRow hover>
                                                                    <TableCell>種別</TableCell>
                                                                    <TableCell>{row.type}</TableCell>
                                                                </TableRow>
                                                                <TableRow hover>
                                                                    <TableCell>車名</TableCell>
                                                                    <TableCell>{row.name}</TableCell>
                                                                </TableRow>
                                                                <TableRow hover>
                                                                    <TableCell colspan={2} className={classes.center}>
                                                                        <Button
                                                                            variant="contained"
                                                                            color="default"
                                                                            style={{ margin: 8 }}
                                                                            onClick={(event) => { handleAutomobileEdit(index, event) }}
                                                                            startIcon={<EditIcon/>}
                                                                            className={classes.operating}
                                                                        >
                                                                        編集
                                                                        </Button>
                                                                        <Button
                                                                            variant="contained"
                                                                            color="default"
                                                                            style={{ margin: 8 }}
                                                                            onClick={(event) => { handleDialogOpen(index) }}
                                                                            startIcon={<DeleteIcon/>}
                                                                            className={classes.operating}
                                                                        >
                                                                        削除
                                                                        </Button>
                                                                    </TableCell>
                                                                </TableRow>
                                                                </TableBody>
                                                                </>
                                                            );
                                                        })}
                                                    </Table>
                                                </TableContainer>
                                            </Hidden>
                                            </>
                                        );
                                    }else{
                                        return (
                                            <>
                                            <Hidden smDown>
                                            <TableContainer component={Paper} className={classes.list}>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell className={classes.head}>登録番号</TableCell>
                                                            <TableCell className={classes.head}>種別</TableCell>
                                                            <TableCell className={classes.head}>車名</TableCell>
                                                            <TableCell className={classes.head}>&nbsp;</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow hover>
                                                            <TableCell colSpan={4}><Typography>入力している自動車の情報はありません</Typography></TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            </Hidden>

                                            <Hidden mdUp>
                                                <TableContainer component={Paper} className={classes.list}>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell className={classes.head} colspan={2}>財産番号</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            <TableRow hover>
                                                                <TableCell>登録番号</TableCell>
                                                                <TableCell rowspan={4}>入力している自動車の<br/>情報はありません</TableCell>
                                                            </TableRow>
                                                            <TableRow hover>
                                                                <TableCell>種別</TableCell>
                                                            </TableRow>
                                                            <TableRow hover>
                                                                <TableCell>車名</TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Hidden>
                                            </>
                                        )
                                    }
                                })()
                            }
                    </Paper>

                    <Dialog
                        open={open}
                        onClose={handleDialogClose}
                    >
                        <DialogTitle>{"削除確認"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                削除します。よろしいですか?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleDialogClose} color="dafalut">
                                いいえ
                            </Button>
                            <Button onClick={() => { handleAutomobileDelete(deleteTargetIndex) }} color="secondary">
                                はい
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <PropertyMenu execute={handleAutomobile} message={error}/>
                </Grid>
                <Grid item xs={12} lg={6}>
                    <FlowTitle title="財産目録の作成の流れをご説明します。【自動車】" />
                    <FlowItem image="img/icon_list.png" contents="①自動車を入力します。<br>必要項目を入力します。" />
                    <FlowArrow/>
                    <img src="img/automobile.png"/>
                    <FlowArrow/>
                    <FlowItem image="img/icon_person.png" contents="②この財産の取得対象者を入力します。<br>取得対象者の姓名を正確に入力します。" />
                    <FlowArrow/>
                    <FlowItem image="img/icon_check.png" contents="③相続・遺贈を入力します。<br>遺贈とは、遺言によって、遺贈者（遺産を贈る側）の財産の全部、又は<br>一部を、受遺者（遺産を受ける側）に無償で譲与することを言います。" />
                    <FlowArrow/>
                    <FlowItem image="img/icon_list.png" contents="④他の財産を入力する。<br>「メニューから保有する財産を選ぶ」をクリックし、メニューの中<br>から入力したい財産を選んで入力します。" />
                    <GuideHalf pageName="自動車"/>
                </Grid>
            </Grid>

        </Container>
    );
}

export default Automobile
